// removed by extract-text-webpack-plugin
module.exports = {"noDiscount":"price__noDiscount-zosBj","totalPrice":"price__totalPrice-2Q0MM","rouble":"price__rouble-1so9F","lineThrough":"price__lineThrough-VY_qD","priceContent":"price__priceContent-3rBwa"};


//////////////////
// WEBPACK FOOTER
// ./components/common/custom-order/additional-parameters/content/price/price.css
// module id = 804
// module chunks = 0